'use strict';
Object.defineProperty(exports, '__esModule', { value: true });
exports.OperationService = void 0;
var tslib_1 = require('tslib');
var typed_redux_saga_1 = require('typed-redux-saga');
var createDeferred_1 = require('../utils/createDeferred');
var decorators_1 = require('../decorators');
var assertNullable_1 = require('../utils/assertNullable');
var BaseService_1 = require('./BaseService');
var createOperation_1 = require('../utils/createOperation');
var emptyFlow_1 = require('../utils/emptyFlow');
var isNodeEnv_1 = require('../utils/isNodeEnv');
var OperationService = /** @class */ (function (_super) {
    (0, tslib_1.__extends)(OperationService, _super);
    function OperationService(options) {
        var _this = _super.call(this) || this;
        _this._operations = {};
        _this._operationConsumers = {};
        _this._consumerOperations = new WeakMap();
        _this._operationSubscriptions = {};
        _this._hash = options === null || options === void 0 ? void 0 : options.hash;
        return _this;
    }
    OperationService.prototype.toString = function () {
        return 'OperationService';
    };
    OperationService.prototype.createSubscription = function (id, run) {
        var self = this;
        return function subscription() {
            var _i, error, result, defer, e_1;
            var args = [];
            for (_i = 0; _i < arguments.length; _i++) {
                args[_i] = arguments[_i];
            }
            return (0, tslib_1.__generator)(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        error = undefined;
                        result = undefined;
                        self._operationSubscriptions[id] =
                            self._operationSubscriptions[id] || (0, createDeferred_1.createDeferred)();
                        defer = self._operationSubscriptions[id];
                        _a.label = 1;
                    case 1:
                        _a.trys.push([1, 3, 4, 5]);
                        return [5 /*yield**/, (0, tslib_1.__values)((0, typed_redux_saga_1.apply)(this, run, args))];
                    case 2:
                        result = _a.sent();
                        return [3 /*break*/, 5];
                    case 3:
                        e_1 = _a.sent();
                        error = e_1;
                        throw e_1;
                    case 4:
                        if (error) {
                            defer === null || defer === void 0 ? void 0 : defer.reject(error);
                        } else {
                            defer === null || defer === void 0 ? void 0 : defer.resolve(result);
                        }
                        self._operationSubscriptions[id] = undefined;
                        return [7 /*endfinally*/];
                    case 5:
                        return [2 /*return*/, result];
                }
            });
        };
    };
    OperationService.prototype.createOperation = function (_a) {
        var operationArgs = _a.operationArgs,
            _b = _a.ssr,
            ssr = _b === void 0 ? false : _b;
        var self = this;
        var id = operationArgs[0];
        var isNode = (0, isNodeEnv_1.isNodeEnv)();
        var operation = createOperation_1.createOperation.apply(null, operationArgs);
        var originRun = operation.run;
        operation.run = this.createSubscription(id, function () {
            var _i, _a, ssrArgs_1, result_1, sameArgs, result;
            var _b;
            var args = [];
            for (_i = 0; _i < arguments.length; _i++) {
                args[_i] = arguments[_i];
            }
            return (0, tslib_1.__generator)(this, function (_c) {
                switch (_c.label) {
                    case 0:
                        if (!isNode) {
                            if ((_b = self._hash) === null || _b === void 0 ? void 0 : _b[id]) {
                                (_a = self._hash[id]), (ssrArgs_1 = _a.args), (result_1 = _a.result);
                                sameArgs =
                                    ssrArgs_1.length === args.length &&
                                    ssrArgs_1.every(function (arg, i) {
                                        return ssrArgs_1[i] === args[i];
                                    });
                                delete self._hash[id];
                                if (sameArgs) {
                                    return [2 /*return*/, result_1];
                                }
                            }
                        }
                        return [
                            5 /*yield**/,
                            (0, tslib_1.__values)((0, typed_redux_saga_1.apply)(this, originRun, args)),
                        ];
                    case 1:
                        result = _c.sent();
                        if (isNode && ssr && self._hash) {
                            self._hash[id] = { args: args, result: result };
                        }
                        return [2 /*return*/, result];
                }
            });
        });
        this._operations[id] = operation;
        return operation;
    };
    OperationService.prototype.getHash = function () {
        return this._hash;
    };
    OperationService.prototype.subscribeOperation = function (operationId) {
        var defer = this._operationSubscriptions[operationId] || (0, createDeferred_1.createDeferred)();
        this._operationSubscriptions[operationId] = defer;
        return defer.promise;
    };
    OperationService.prototype.registerConsumer = function (consumer, operationId) {
        var operations;
        return (0, tslib_1.__generator)(this, function (_a) {
            if (!this._consumerOperations.has(consumer)) {
                this._consumerOperations.set(consumer, {});
            }
            operations = this._consumerOperations.get(consumer);
            (0, assertNullable_1.assertNullable)(operations);
            operations[operationId] = operationId;
            this._operationConsumers[operationId] = this._operationConsumers[operationId] || new Set();
            this._operationConsumers[operationId].add(consumer);
            return [2 /*return*/];
        });
    };
    OperationService.prototype.unregisterConsumer = function (consumer, operationId) {
        var operations, operationsToDestroy, operationsToDestroy_1, operationsToDestroy_1_1, o, e_2_1;
        var e_2, _a;
        var _b;
        return (0, tslib_1.__generator)(this, function (_c) {
            switch (_c.label) {
                case 0:
                    operations = this._consumerOperations.get(consumer);
                    if (operations) {
                        if (operationId) {
                            delete operations[operationId];
                        } else {
                            this._consumerOperations.delete(consumer);
                        }
                    }
                    operationsToDestroy = operationId ? [operationId] : operations ? Object.keys(operations) : [];
                    if (
                        !(operationsToDestroy === null || operationsToDestroy === void 0
                            ? void 0
                            : operationsToDestroy.length)
                    ) {
                        return [2 /*return*/];
                    }
                    _c.label = 1;
                case 1:
                    _c.trys.push([1, 6, 7, 8]);
                    (operationsToDestroy_1 = (0, tslib_1.__values)(operationsToDestroy)),
                        (operationsToDestroy_1_1 = operationsToDestroy_1.next());
                    _c.label = 2;
                case 2:
                    if (!!operationsToDestroy_1_1.done) return [3 /*break*/, 5];
                    o = operationsToDestroy_1_1.value;
                    this._operationConsumers[o].delete(consumer);
                    if (!(this._operationConsumers[o].size === 0)) return [3 /*break*/, 4];
                    delete this._operationConsumers[o];
                    return [
                        5 /*yield**/,
                        (0, tslib_1.__values)(
                            (0, typed_redux_saga_1.call)(
                                ((_b = this._operations[o]) === null || _b === void 0 ? void 0 : _b.destroy) ||
                                    emptyFlow_1.emptyFlow
                            )
                        ),
                    ];
                case 3:
                    _c.sent();
                    _c.label = 4;
                case 4:
                    operationsToDestroy_1_1 = operationsToDestroy_1.next();
                    return [3 /*break*/, 2];
                case 5:
                    return [3 /*break*/, 8];
                case 6:
                    e_2_1 = _c.sent();
                    e_2 = { error: e_2_1 };
                    return [3 /*break*/, 8];
                case 7:
                    try {
                        if (
                            operationsToDestroy_1_1 &&
                            !operationsToDestroy_1_1.done &&
                            (_a = operationsToDestroy_1.return)
                        )
                            _a.call(operationsToDestroy_1);
                    } finally {
                        if (e_2) throw e_2.error;
                    }
                    return [7 /*endfinally*/];
                case 8:
                    return [2 /*return*/];
            }
        });
    };
    (0, tslib_1.__decorate)(
        [
            (0, decorators_1.daemon)(decorators_1.DaemonMode.Every),
            (0, tslib_1.__metadata)('design:type', Function),
            (0, tslib_1.__metadata)('design:paramtypes', [Object, String]),
            (0, tslib_1.__metadata)('design:returntype', void 0),
        ],
        OperationService.prototype,
        'registerConsumer',
        null
    );
    (0, tslib_1.__decorate)(
        [
            (0, decorators_1.daemon)(decorators_1.DaemonMode.Every),
            (0, tslib_1.__metadata)('design:type', Function),
            (0, tslib_1.__metadata)('design:paramtypes', [Object, String]),
            (0, tslib_1.__metadata)('design:returntype', void 0),
        ],
        OperationService.prototype,
        'unregisterConsumer',
        null
    );
    return OperationService;
})(BaseService_1.BaseService);
exports.OperationService = OperationService;
